module.exports = __webpack_public_path__ + "img/style-light.fa8e4dc3.png";